<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ $t('user_profile') }}</h2>
			<div class="lg:flex">
				<div class="lg:pr-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="name">{{ $t('Nombre') }}</label>
					<input
						type="text"
						v-model="user.name"
						id="name"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.user.name.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.user.name.required"
						>
							{{ $t('name_required') }}
						</div>
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.user.name.maxLength"
						>
							{{ $t('name_validation') }}
						</div>
					</div>
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="lastname">{{ $t('Apellido') }}</label>
					<input
						type="text"
						v-model="user.lastname"
						id="lastname"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.user.lastname.$dirty">
						<!-- <div class="text-sm text-red-500 mt-2" v-if="!$v.user.lastname.required">{{ $t('lastname_requerid') }}</div> -->
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.user.lastname.maxLength"
						>
							{{ $t('lastname_validation') }}
						</div>
					</div>
				</div>
			</div>

			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2">{{ $t('DNI') }}</label>
					<input
						type="text"
						disabled
						v-model="user.dni"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.user.dni.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.user.dni.required">
							{{ $t('dni_required') }}
						</div>
					</div>
				</div>
				<div class="lg:w-3/6 lg:pr-5 mb-4">
					<label class="block mb-2" for="name">{{ $t('Email') }}</label>
					<input
						type="email"
						v-model="user.email"
						id="email"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.user.email.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.user.email.required"
						>
							{{ $t('email_required') }}
						</div>
						<div class="font-12 text-red-500 mt-2" v-if="!$v.user.email.email">
							{{ $t('email_invalido') }}
						</div>
					</div>
				</div>
				<div class="lg:pl-5 lg:w-3/6 mb-4">
					<label class="block mb-2" for="mobile">{{ $t('Telefono') }}:</label>
					<input
						type="number"
						v-model="user.mobile"
						id="mobile"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2">{{ $t('state') }}</label>
					<select
						v-model="user.address_state_id"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					>
						<option
							v-for="(state, index) in states"
							:value="state.id"
							:key="index"
						>
							{{ state.name }}
						</option>
					</select>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2">{{ $t('address') }}</label>
					<input
						type="text"
						v-model="user.address"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2">{{ $t('zipcode') }}</label>
					<input
						type="number"
						v-model="user.address_zipcode"
						class="
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
					<div v-if="$v.user.address_zipcode.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.user.address_zipcode.maxLength"
						>
							{{ $t('zipcode_validation') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="mb-4 lg:w-3/6">
					<label class="block mb-2" for="rol_id">{{ $t('user_rol') }}</label>
					<span>{{ user.rol }}</span>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pr-5">
					<label class="block mb-2" for="office_id">{{ $t('office') }}</label>
					<span>{{ user.office }}</span>
				</div>
				<div class="mb-4 lg:w-3/6 lg:pl-5">
					<label class="block mb-2" for="team_id">{{ $t('team') }}</label>
					<span>{{ user.team }}</span>
				</div>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ $t('update') }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4 text-sm">
				<p>{{ $t('server_error') }}.</p>
				<p class="text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { single } from '@/mixins'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import { fetchStatesSelect } from '@/apollo/states'
import { fetchUserProfile } from '@/apollo/users'
import { updateUserProfile } from '@/apollo/users'

export default {
	mixins: [single],
	components: { PulseLoader },
	apollo: {
		states: fetchStatesSelect(),
		user() {
			return fetchUserProfile(this.$store.state.login.user.id)
		}
	},
	data() {
		return {
			user: {
				name: '',
				email: '',
				lastname: '',
				mobile: '',
				rol: '',
				office: '',
				team: '',
				dni: '',
				address: '',
				address_state_id: null,
				address_zipcode: ''
			},
			states: []
		}
	},
	validations: {
		user: {
			name: {
				required,
				maxLength: maxLength(50)
			},
			email: {
				required,
				email
			},
			lastname: {
				maxLength: maxLength(50)
			},
			dni: {
				required
			},
			address_zipcode: {
				maxLength: maxLength(10)
			}
		}
	},
	methods: {
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.updateUserProfile()
					.then(() => this.stopLoadingState())
					.catch(error => {
						this.setError(error)
					})
			} else {
				this.setError(this.$t('form_validation'))
			}
		},
		updateUserProfile() {
			return this.$apollo.mutate(
				updateUserProfile(this.$store.state.login.user.id, this.user)
			)
		}
	}
}
</script>
